var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconCate02 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 18 14"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#000",
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.667 2.667H.333V.933h17.334zM17.667 8.083H.333V6.35h17.334zM17.667 13.5H.333v-1.733h17.334z"
}))));
export default SvgIconCate02;